import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import signupImage from "../images/signup.png";
import axios from "axios";
import { API_URL } from "../components/Constant";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import OTPInput from "../components/Otp";
import avr1 from "../images/avr1.png";
import avr2 from "../images/avr2.png";
import avr3 from "../images/avr3.png";
import avr4 from "../images/avr4.png";
import avr5 from "../images/avr5.png";
import avr6 from "../images/avr6.png";
import avr7 from "../images/avr7.png";
import avr8 from "../images/avr8.png";
import avr9 from "../images/avr9.png";
import avr10 from "../images/avr10.png";
import avr11 from "../images/avr11.png";
import avr12 from "../images/avr12.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import { useSearchParams } from "react-router-dom";
import Colors from "../components/Colors";
import TextfieldComponent from "../components/TextfeildComponent";

function PlayerSignUp() {
  const passwordMap = {
    lion: avr1,
    tiger: avr2,
    squirrel: avr3,
    pig: avr4,
    rabbit: avr5,
    cat: avr6,
    blueberry: avr7,
    mango: avr8,
    apple: avr9,
    orenge: avr10,
    strawberry: avr11,
    grape: avr12,
  };

  const [searchParams] = useSearchParams();
  const referralId = searchParams.get("referral");

  console.log("Referral ID:", referralId);

  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [nameError, setNameError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [countryCodeError, setCountryCodeError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [signupError, setSignupError] = useState("");
  const [isOtp, setIsOtp] = useState(false);
  const [isOtpSuccess, setIsOtpSuccess] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const [selectedAnimal, setSelectedAnimal] = useState("");
  const [selectedFruit, setSelectedFruit] = useState("");

  // Separate animals and fruits
  const animals = Object.keys(passwordMap).slice(0, 6);
  const fruits = Object.keys(passwordMap).slice(6);

  const handleAnimalSelect = (animal) => {
    setSelectedAnimal(animal);
    setPassword(`${animal}${selectedFruit}`);
    setPasswordError("");
    setSignupError("");
  };

  const handleFruitSelect = (fruit) => {
    setSelectedFruit(fruit);
    setPassword(`${selectedAnimal}${fruit}`);
    setPasswordError("");
    setSignupError("");
  };

  // Handle change for name field
  const handleNameChange = (e) => {
    setName(e.target.value);
    setNameError("");
    setSignupError("");
  };

  const handleCountryCodeChange = (e) => {
    let newValue = e.target.value;
    if (/^\+?\d*$/.test(newValue)) {
      if (newValue.length <= 4) {
        setCountryCode(newValue);
      }
    }
    setCountryCodeError("");
    setPhoneNumberError("");
    setSignupError("");
  };

  const handlePhoneChange = (e) => {
    const newValue = e.target.value;
    if (/^\d*$/.test(newValue) && newValue.length <= 10) {
      setPhoneNumber(newValue);
    }
    setPhoneNumberError("");
    setCountryCodeError("");
    setSignupError("");
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordError("");
    setSignupError("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const sanitizeName = (name) => name.trim();

  // Handle form submission (Register button click)
  // const handleRegister = async() => {

  //   const country = countryCode.replace(/^\+/, '')
  //   const playerName = sanitizeName(name)
  //   console.log(playerName)
  //   {console.log("password", password)}
  //   {console.log("passwordanimal", selectedAnimal)}
  //   {console.log("passwordfruit", selectedFruit)}

  //     if (name.trim() === "") {
  //         setNameError("Please enter your name");
  //     }
  //     else if (name.length > 60) {
  //         setNameError("Name is too long.");
  //     }
  //     else if (country.trim() === "") {
  //         setCountryCodeError("Please enter your country code");
  //     }
  //     else if (phoneNumber.trim() === "") {
  //         setPhoneNumberError("Please enter your phone number");
  //     }
  //     else if (selectedAnimal.trim() === "" && selectedFruit.trim() === "") {
  //       setPasswordError("Please choose your password by selecting an animal and a fruit image.");
  //     } else if (selectedAnimal.trim() === "") {
  //       setPasswordError("Please select an animal image to proceed.");
  //     } else if (selectedFruit.trim() === "") {
  //       setPasswordError("Please select a fruit image to proceed.");
  //     }

  //   else {

  //     try {
  //         // First API call to check if the phone number exists
  //         const response = await axios.post(`${API_URL}/check_phone_number_exist`, {
  //             countryCode: countryCode,
  //             phone: phoneNumber,
  //             name: playerName,
  //         });

  //         if (response.data.success === true) {
  //           const country = countryCode.replace(/^\+/, '');
  //           const ipResponse = await axios.get('https://api64.ipify.org?format=json');
  //           const userIP = ipResponse.data.ip;

  //           try {
  //             const response = await axios.post(`${API_URL}/insert_player_details`, {
  //               name: playerName,
  //               countryCode: country,
  //               phone: phoneNumber,
  //               password: password,
  //               ip_address: userIP
  //             });

  //             console.log(response.data);

  //             if (response.data.success) {

  //               localStorage.setItem('PlayerId', response.data.player_id);
  //               localStorage.setItem('PlayerTocken', response.data.tocken);
  //               window.location.href = '/player-landing';
  //             }
  //           } catch (error) {
  //             console.error('Something went wrong:', error);
  //           }

  //         } else {
  //             // Handle errors from the phone number check
  //             setSignupError(response.data.error || 'Phone number does not exist.');
  //         }
  //     } catch (error) {
  //         // Handle errors from the phone number check API call
  //         console.error("Phone number check request failed:", error);

  //         if (error.response && error.response.data) {
  //             // API returned a response with an error message
  //             setSignupError(error.response.data.message || 'Phone number check failed.');
  //         } else {
  //             // Network or other unknown error
  //             setSignupError('An error occurred while checking the phone number. Please try again.');
  //         }
  //     }

  //  }

  // };
  const handleRegister = async () => {
    if (isRegistering) return; // Prevent multiple clicks

    setIsRegistering(true); // Disable the button

    const country = countryCode.replace(/^\+/, "");
    const playerName = sanitizeName(name);
    const trimmedPassword = password.trim();
    if (name.trim() === "") {
      setNameError("Please enter your name");
      setIsRegistering(false);
      return;
    }
    if (name.length > 60) {
      setNameError("Name is too long.");
      setIsRegistering(false);
      return;
    }
    if (country.trim() === "") {
      setCountryCodeError("Please enter your country code");
      setIsRegistering(false);
      return;
    }
    if (phoneNumber.trim() === "") {
      setPhoneNumberError("Please enter your phone number");
      setIsRegistering(false);
      return;
    }
    if (password.trim() === "") {
      setPasswordError(
        "Please choose your password.",
      );
      setIsRegistering(false);
      return;
    }
   

    try {
      // Check if phone number exists
      const response = await axios.post(`${API_URL}/check_phone_number_exist`, {
        countryCode: countryCode,
        phone: phoneNumber,
        name: playerName,
      });

      if (response.data.success) {
        const ipResponse = await axios.get(
          "https://api64.ipify.org?format=json",
        );
        const userIP = ipResponse.data.ip;

        try {
          // Register the player
          const response = await axios.post(
            `${API_URL}/insert_player_details`,
            {
              name: playerName,
              countryCode: country,
              phone: phoneNumber,
              password: trimmedPassword,
              ip_address: userIP,
            },
          );

          if (response.data.success) {
            localStorage.setItem("PlayerId", response.data.player_id);
            localStorage.setItem("PlayerTocken", response.data.tocken);
            window.location.href = "/player-landing";
          }
        } catch (error) {
          console.error("Something went wrong:", error);
          setSignupError("Registration failed. Please try again.");
        }
      } else {
        setSignupError(response.data.error || "Phone number does not exist.");
      }
    } catch (error) {
      console.error("Phone number check request failed:", error);
      setSignupError(
        "An error occurred while checking the phone number. Please try again.",
      );
    }

    setIsRegistering(false); // Re-enable the button after request completes
  };

  const handleSignInButtonClick = () => {
    window.location.href = "/player-signin";
  };

  useEffect(() => {
    console.log(isOtpSuccess);

    if (isOtpSuccess) {
      const insertPlayerData = async () => {
        const country = countryCode.replace(/^\+/, "");

        try {
          const response = await axios.post(
            `${API_URL}/insert_player_details`,
            {
              name: name,
              countryCode: country,
              phone: phoneNumber,
              password: password,
            },
          );

          console.log(response.data);

          if (response.data.success) {
            setIsOtp(false);
            localStorage.setItem("PlayerId", response.data.player_id);
            localStorage.setItem("PlayerTocken", response.data.tocken);
            window.location.href = "/player-landing";
          }
        } catch (error) {
          console.error("Something went wrong:", error);
        }
      };

      // Call the function
      insertPlayerData();
    }
  }, [isOtpSuccess]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        background: Colors.Tidesbg,
        width: "100%",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          background: Colors.signupboxbg,
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: { md: "40%", xs: "90%" },
          maxHeight: { md: "82%", xs: "60%" },
          borderRadius: "28px",
          borderColor: "#ee8e4c !important",
          border: "2px solid",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "100%",
            gap: "32px",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: { md: "95%", xs: "90%" },
            maxHeight: "90%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: { md: "80%", xs: "100%" },
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "fit-content",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontSize: "28px",
                  fontWeight: 600,
                  color: "#fff",
                }}
              >
                Welcome!
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "fit-content",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: "4px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                    color: "#fff",
                  }}
                >
                  Nick name:
                </Typography>
                <TextfieldComponent value={name} onChange={handleNameChange} />

                {nameError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {nameError}
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  height: "fit-content",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "8px",
                }}
              >
                <Box sx={{ width: { md: "20%", xs: "35%" } }}>
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                      color: "#fff",
                    }}
                  >
                    Country code:
                  </Typography>
                  <TextfieldComponent
                    value={countryCode}
                    onChange={handleCountryCodeChange}
                  />
                </Box>
                <Box sx={{ width: { md: "80%", xs: "65%" } }}>
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                      color: "#fff",
                    }}
                  >
                    Phone number:
                  </Typography>
                  <TextfieldComponent
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                  />
                </Box>
              </Box>
              {countryCodeError && (
                <Typography
                  sx={{
                    color: "red",
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                  }}
                >
                  {countryCodeError}
                </Typography>
              )}
              {phoneNumberError && (
                <Typography
                  sx={{
                    color: "red",
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                  }}
                >
                  {phoneNumberError}
                </Typography>
              )}

            <Box sx={{
                display: 'flex', flexDirection: 'column', width: '100%', height: 'fit-content',
                justifyContent: 'center', alignItems: 'flex-start', gap: '4px'
              }}>
                 <Typography sx={{ fontFamily: 'Roboto', fontSize: { xs: '12px', md: '14px' },
                 fontWeight: 400,color:'#fff', }}>Password:</Typography>
                <TextfieldComponent
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={handlePasswordChange}                  
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ marginRight: '10px' }}>
                        <IconButton onClick={togglePasswordVisibility} edge="end">
                          {!showPassword ? (
                            <VisibilityOff sx={{ color: '#ee8e4c' }} />
                          ) : (
                            <Visibility sx={{ color: '#ee8e4c' }} />
                          )}
                        </IconButton>
                      </InputAdornment>

                ),       
      }}
     
    />
               



                


                {passwordError && <Typography sx={{ color: 'red', fontFamily: 'Roboto', fontSize: { xs: '12px', md: '14px' }, fontWeight: 400 }}>
                  {passwordError}</Typography>}
              </Box>  
              {/* <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "fit-content",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: "4px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                    color: "#FFF",
                  }}
                >
                  Pick one animal and one fruit to create your password:
                </Typography>

                <Box style={{ width: "100%" }}>
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "8px",
                      flexWrap: "nowrap",
                    }}
                  >
                    {animals.map((animal) => (
                      <label
                        key={animal}
                        style={{
                          position: "relative",
                          textAlign: "center",
                          cursor: "pointer",
                          flex: "1 1 0", // Ensures equal distribution of width
                        }}
                        onClick={() => handleAnimalSelect(animal)} // Clicking the label will toggle the checkbox
                      >
                        <input
                          type="checkbox"
                          name="animal"
                          value={animal}
                          onChange={() => handleAnimalSelect(animal)}
                          checked={selectedAnimal === animal}
                          style={{
                            position: "absolute",
                            top: "1px",
                            right: "1px",
                            zIndex: 2,
                            cursor: "pointer",
                            accentColor: "red",
                          }}
                        />
                        <img
                          src={passwordMap[animal]}
                          alt={animal}
                          style={{
                            width: "100%", // Images will occupy the full width of their container
                            height: "auto",
                            borderRadius: "4px",
                            border:
                              selectedAnimal === animal
                                ? "1px solid #B14E64"
                                : "none",
                          }}
                        />
                      </label>
                    ))}
                  </Box>
                </Box>

                <Box style={{ textAlign: "center", width: "100%" }}>
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "8px",
                      flexWrap: "nowrap",
                    }}
                  >
                    {fruits.map((fruit) => (
                      <label
                        key={fruit}
                        style={{
                          position: "relative",
                          textAlign: "center",
                          cursor: "pointer",
                          flex: "1 1 0", // Ensures equal distribution of width
                        }}
                        onClick={() => handleFruitSelect(fruit)} // Clicking the label will toggle the radio button
                      >
                        <input
                          type="checkbox"
                          name="fruit"
                          value={fruit}
                          onChange={() => handleFruitSelect(fruit)}
                          checked={selectedFruit === fruit}
                          style={{
                            position: "absolute",
                            top: "1px",
                            right: "1px",
                            zIndex: 2,
                            cursor: "pointer",
                            accentColor: "red",
                          }}
                        />
                        <img
                          src={passwordMap[fruit]}
                          alt={fruit}
                          style={{
                            width: "100%", // Images will occupy the full width of their container
                            height: "auto",
                            borderRadius: "4px",
                            border:
                              selectedFruit === fruit
                                ? "1px solid #B14E64"
                                : "none",
                          }}
                        />
                      </label>
                    ))}
                  </Box>
                </Box>

                {passwordError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {passwordError}
                  </Typography>
                )}
              </Box> */}

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "100%",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "8px",
                  marginTop: { md: "16px", xs: "16px" },
                }}
              >
                <Button
                  onClick={handleRegister}
                  disabled={isRegistering}
                  sx={{
                    background: Colors.button2,
                    color: Colors.button2font,
                    height: { md: "36px", xs: "32px" },
                    width: "100%",
                    border: "1px solid",
                    borderColor: Colors.button2Border,
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "12px",
                    transition: "background 0.3s, transform 0.3s",
                    "&:hover": {
                      background: Colors.button2,
                      transform: "scaleY(1.05)",
                    },
                    "&:active": {
                      background: Colors.button2,
                    },
                  }}
                >
                  {isRegistering ? "Registering..." : "Register"}
                </Button>
                {signupError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {signupError}
                  </Typography>
                )}
              </Box>

              <Typography
                sx={{ fontSize: { xs: "12px", md: "16px" }, color: "#fff" }}
              >
                Already have an account?
                <Typography
                  component="span"
                  sx={{
                    color: "#ee8e4c",
                    display: "inline",
                    marginLeft: { xs: "4px", md: "8px" },
                    fontSize: { xs: "14px", md: "20px" },
                    cursor: "pointer",
                  }}
                  onClick={handleSignInButtonClick}
                >
                  Sign in
                </Typography>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {isOtp && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: "1000",
          }}
        >
          <Box
            sx={{
              width: { md: "25%", sm: "35%", xs: "75%" },
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "36px",
            }}
          >
            {/* Close Button */}
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <IconButton
                onClick={() => {
                  setIsOtp(false); // Reset the game state
                  window.location.reload(); // Refresh the page
                }}
                sx={{
                  color: "#6b6b6b",
                  "&:hover": {
                    color: "#000000",
                  },
                }}
              >
                <CloseOutlinedIcon />
              </IconButton>
            </Box>

            <OTPInput
              phoneNumber={phoneNumber}
              countryCode={countryCode}
              setIsOtpSuccess={setIsOtpSuccess}
            ></OTPInput>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default PlayerSignUp;
